import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import {connect} from 'react-redux';
import {getResources} from 'redux-resource';
import {withFormik} from 'formik';
import yup from 'yup';
import AdminCollectionDetails from '../details/form';
import {COLLECTION_LANGUAGE_EN} from '../languages';

function mapStateToProps(state) {
	const languages = getResources(state.languages, 'all');

	return {
		languages
	};
}

const schema = yup.object()
	.shape({
		name: yup.string().ensure()
			.max(50, 'The title must be less than 50 characters')
			.required('The title is required field'),
		description: yup.string().ensure().max(100, 'The description must be less than 100 characters'),
		language: yup.string().ensure().required().default(COLLECTION_LANGUAGE_EN),
		sortOrder: yup.string().ensure()
			.max(5, 'The sort order must be less than 5 characters')
			.matches(/^[0-9]+$|^$/, 'The sort order must be a number'),
		poster: yup.string().ensure()
	}).required();

const enhance = compose(
	connect(mapStateToProps),
	withFormik({
		mapPropsToValues(props) {
			return schema.cast(props.item || {});
		},
		handleSubmit(values, {props}) {
			props.doSubmit(values);
		},
		validationSchema: schema
	}),
	lifecycle({
		componentWillUnmount() {
			const {props: {values: {posterTask}}} = this;

			if (posterTask && posterTask.isPending) {
				posterTask.cancel();
			}
		}
	})
);

export default enhance(AdminCollectionDetails);



// WEBPACK FOOTER //
// ./src/client/components/admin/collections/details/index.js